import styled, { css } from "styled-components";
import {
    type DisplayProps,
    type SpaceProps,
    type TypographyProps,
    display,
    space,
    color,
    typography,
    compose,
} from "styled-system";
import type { ThemeTypedColorProps } from "../../themes/common";

const styleProps = compose(display, space, color, typography);
const Text = styled.div<
    { weight?: string; lineThrough?: boolean; ellipsis?: boolean; small?: boolean } & DisplayProps &
        SpaceProps &
        TypographyProps &
        ThemeTypedColorProps
>`
    position: relative;

    ${styleProps};

    ${({ lineThrough }) =>
        lineThrough &&
        css`
            text-decoration: line-through;
        `};

    ${({ weight, theme }) =>
        weight === "bold" &&
        css`
            font-family: ${theme.fontFamily.bold};
        `};

    ${({ weight, theme }) =>
        weight === "light" &&
        css`
            font-family: ${theme.fontFamily.light};
        `};

    ${({ small }) =>
        small &&
        css`
            font-size: 1.3rem;
            line-height: 2rem;
        `};

    ${({ ellipsis }) =>
        ellipsis &&
        css`
            display: block;
            max-width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        `};
`;

export default Text;
